import { Component, input } from '@angular/core';

@Component({
  selector: 'app-content-container',
  template: `
    <div class="flex justify-center items-center">
      <div class="w-full {{ classes() }}">
        <ng-content />
      </div>
    </div>
  `,
})
export class ContentContainerComponent {
  public readonly classes = input<string>('max-w-content-width');
}
